import { CustomArrowProps as SlickProps } from "react-slick";
import cn from "classnames";
import { ChevronRight } from "lucide-react";

interface CarouselArrowProps extends SlickProps {
  direction: "left" | "right";
  overTheContainer?: boolean;
}

const CarouselArrow = (props: CarouselArrowProps) => {
  const { onClick, direction, overTheContainer } = props;
  return (
    <button
      type="button"
      aria-label={direction === "left" ? "Slide precedente" : "Slide successivo"}
      className={cn("carousel-arrow absolute top-1/2 -translate-y-1/2", {
        'rotate-180': direction === "left",
        '-right-8': direction === "right" && overTheContainer,
        '-left-8': direction === "left" && overTheContainer,
        'right-0': direction === "right" && !overTheContainer,
        'left-0': direction === "left" && !overTheContainer,
      })}
      onClick={onClick}
    >
      <ChevronRight className="w-6 h-6" color="white" aria-hidden="true" />
    </button>
  );
}

export default CarouselArrow;
